import { __rest } from "tslib";
import * as React from 'react';
const ChevronLeftXLarge = (_a) => {
    var { size } = _a, props = __rest(_a, ["size"]);
    return (React.createElement("svg", Object.assign({ viewBox: "0 0 60 60", fill: "currentColor", width: size || "60", height: size || "60" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M42.042424,6 L42.7495308,6.70710678 L19.411,30.044 L42.7487373,53.3823029 L42.0416306,54.0894096 L18,30.0477791 L18.003,30.044 L18.0007935,30.0416306 L42.042424,6 Z" })));
};
ChevronLeftXLarge.displayName = 'ChevronLeftXLarge';
export default ChevronLeftXLarge;
//# sourceMappingURL=ChevronLeftXLarge.js.map